import { render, staticRenderFns } from "./TrucksRoadTable.vue?vue&type=template&id=35cdab17&scoped=true"
import script from "./TrucksRoadTable.vue?vue&type=script&lang=js"
export * from "./TrucksRoadTable.vue?vue&type=script&lang=js"
import style0 from "./TrucksRoadTable.vue?vue&type=style&index=0&id=35cdab17&prod&scoped=true&lang=scss"
import style1 from "./TrucksRoadTable.vue?vue&type=style&index=1&id=35cdab17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdab17",
  null
  
)

export default component.exports